import {Button, Form} from 'react-bootstrap';
import {React,useState,useEffect} from 'react';
import styled from 'styled-components';
import { getcontactUsById, updateContactUs } from '../../api/axios';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import CmsCircularProgress from '../../Components/Common/CircularProgress';
import { showToast } from '../../Utills/toast';
import FormGroup from '../../Components/Common/FormGroup';
import PhoneNumberInput from '../../Components/Common/PhoneInput/PhoneNumberInput';
import { Formik } from "formik";
import * as Yup from "yup";

// Validation schema
const validationSchema = Yup.object({
  mailing_address: Yup.string().required("Mailing address is required"),
  email_address: Yup.string().required("Email address is required"),
  header_paragraph: Yup.string().required("Paragraph is required"),
});

function EditContactUs() {

  const { id, partnerId } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [saving, setSaving] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [initialData, setInitialData] = useState(null);
    
  useEffect(() => {
    const fetchData = async () => {
      if (!id) {
        return;
      }
      try {
        const res = await getcontactUsById(id);
        const blogData = res.data.data[0];
        setData(blogData);
        
        const formData = {
          phoneNo: blogData.phoneNo || "",
          mailing_address: blogData.mailing_address || "",
          email_address: blogData.email_address || "",
          header_paragraph: blogData.header_paragraph || "",
        };

        setInitialData(formData);
      } catch (err) {
        console.log(err);
      } finally {
        setIsLoading(false);
      }
    };
    
    fetchData();
  }, [id]);      
      
  const handleSubmit = async (values) => {
    setSaving(true);

    var formData = {
      phoneNo: values.phoneNo,
      mailing_address: values.mailing_address,
      email_address: values.email_address,
      header_paragraph: values.header_paragraph,
    };

    try {
      const res = await updateContactUs(id, formData);
      console.log(res);
      if (res.status === 200) {
        showToast({
          type: 'success',
          message: res?.data?.message || 'Contact Us details have been updated successfully!', 
        });
        console.log(res.data);
      } else {
        showToast({
          type: 'error',
          message: res?.data?.message || 'Failed to update contact us details. Please try again.',
        });
        Promise.resolve();
      }
      setSaving(false);
    } catch (err) {
      showToast({
        type: 'error',
        message: err?.response?.data?.message || 'Failed to update contact us details. Please try again.',
      });
      console.log(err);
      setSaving(false);
    }
  };

  const handleClick = () => {
    navigate(`/${partnerId}/contactUs`);
  }
  return (
    <>
    {isLoading ? <CmsCircularProgress/> : 
      <ContentWrapper>
        <Formik
          initialValues={initialData}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize={true}
        >
          {({ handleSubmit, getFieldProps, setFieldValue, values, errors, touched }) => (
            <Form onSubmit={handleSubmit} noValidate>
              <Title className='mt-3'>Edit Contact US details</Title><br/>
              <FormGroup 
                label='Phone Number'
              >
                <PhoneNumberInput
                  label='Phone Number'
                  name="phone_number"
                  value={values.phoneNo}
                  onChange={(value, country) => {
                    setFieldValue("phoneNo", value);
                  }}
                />
              </FormGroup>
              <FormGroup 
                label='Mailing Address'
                requiredField
                error={touched.mailing_address && errors.mailing_address}
              >
                <Form.Control
                  type="text"
                  placeholder="Enter mailing address"
                  {...getFieldProps("mailing_address")}
                  isInvalid={touched.mailing_address && errors.mailing_address}
                />
              </FormGroup>
              <FormGroup 
                label='Email Address'
                requiredField
                error={touched.email_address && errors.email_address}
              >
                <Form.Control
                  type="text"
                  placeholder="Enter email address"
                  {...getFieldProps("email_address")}
                  isInvalid={touched.email_address && errors.email_address}
                />
              </FormGroup>
              <FormGroup 
                label='Paragraph'
                requiredField
                error={touched.header_paragraph && errors.header_paragraph}
              >
                <Form.Control
                  as="textarea"
                  rows={5}
                  placeholder="Enter paragraph"
                  maxLength="60"
                  {...getFieldProps("header_paragraph")}
                  isInvalid={touched.header_paragraph && errors.header_paragraph}
                />
              </FormGroup>
        
              <ButtonWrapper className='mt-3'>
                  <Button variant="secondary" onClick={handleClick} >Close</Button>
                  <Button
                    variant="primary"
                    type="submit"                  
                    disabled={saving}
                  >
                    {saving ? "Saving..." : "Save Changes"}
                </Button>
              </ButtonWrapper> 
            </Form>
          )}
        </Formik>
      </ContentWrapper>}
    </>
  );
      
}

export default EditContactUs;

const ContentWrapper = styled.div`
    /* display: flex;
    justify-content: center; */
    padding: 0rem 22rem 1rem 22rem;
`;

const Title = styled.h3`
  text-align: center;
`;

const ButtonWrapper = styled.div`
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 5rem;
`;